export default __webpack_public_path__ + "static/media/logo-wide.15286235.png";